<template>
  <div>
    <div class="tw-overflow-x-auto tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur">
      <table class="tw-min-w-full tw-text-left tw-text-sm tw-text-slate-700 tw-border-separate tw-border-spacing-0">
        <thead class="tw-bg-slate-50/70 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">
          <tr>
            <th class="tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors" @click="updateSortBy('containerId')">
              <div class="tw-inline-flex tw-items-center tw-gap-2">
                <span>Container number</span>
                <font-awesome-icon 
                  :icon="sortBy === 'containerId' && sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down'" 
                  class="tw-h-3 tw-w-3"
                  :class="sortBy === 'containerId' ? 'tw-text-slate-900' : 'tw-text-slate-300'" 
                />
              </div>
            </th>

            <th class="tw-px-4 tw-py-3">Order Type</th>
            <th class="tw-px-4 tw-py-3">Size/Type</th>

            <th class="tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors" @click="updateSortBy('bl')">
              <div class="tw-inline-flex tw-items-center tw-gap-2">
                <span>BL/BKG</span>
                <font-awesome-icon 
                  :icon="sortBy === 'bl' && sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down'" 
                  class="tw-h-3 tw-w-3"
                  :class="sortBy === 'bl' ? 'tw-text-slate-900' : 'tw-text-slate-300'" 
                />
              </div>
            </th>

            <th class="tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors" @click="updateSortBy('origin')">
              <div class="tw-inline-flex tw-items-center tw-gap-2">
                <span>Origin</span>
                <font-awesome-icon 
                  :icon="sortBy === 'origin' && sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down'" 
                  class="tw-h-3 tw-w-3"
                  :class="sortBy === 'origin' ? 'tw-text-slate-900' : 'tw-text-slate-300'" 
                />
              </div>
            </th>

            <th class="tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors" @click="updateSortBy('destination')">
              <div class="tw-inline-flex tw-items-center tw-gap-2">
                <span>Destination</span>
                <font-awesome-icon 
                  :icon="sortBy === 'destination' && sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down'" 
                  class="tw-h-3 tw-w-3"
                  :class="sortBy === 'destination' ? 'tw-text-slate-900' : 'tw-text-slate-300'" 
                />
              </div>
            </th>

            <th class="tw-px-4 tw-py-3">Status</th>

            <th class="tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors" @click="updateSortBy('driver')">
              <div class="tw-inline-flex tw-items-center tw-gap-2">
                <span>Driver</span>
                <font-awesome-icon 
                  :icon="sortBy === 'driver' && sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down'" 
                  class="tw-h-3 tw-w-3"
                  :class="sortBy === 'driver' ? 'tw-text-slate-900' : 'tw-text-slate-300'" 
                />
              </div>
            </th>

            <th class="tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors" @click="updateSortBy('chassis')">
              <div class="tw-inline-flex tw-items-center tw-gap-2">
                <span>Chassis</span>
                <font-awesome-icon 
                  :icon="sortBy === 'chassis' && sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down'" 
                  class="tw-h-3 tw-w-3"
                  :class="sortBy === 'chassis' ? 'tw-text-slate-900' : 'tw-text-slate-300'" 
                />
              </div>
            </th>

            <th class="tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors" @click="updateSortBy('customer')">
              <div class="tw-inline-flex tw-items-center tw-gap-2">
                <span>Customer</span>
                <font-awesome-icon 
                  :icon="sortBy === 'customer' && sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down'" 
                  class="tw-h-3 tw-w-3"
                  :class="sortBy === 'customer' ? 'tw-text-slate-900' : 'tw-text-slate-300'" 
                />
              </div>
            </th>

            <th class="tw-px-4 tw-py-3 tw-cursor-pointer hover:tw-text-slate-900 tw-transition-colors" @click="updateSortBy('receiver')">
              <div class="tw-inline-flex tw-items-center tw-gap-2">
                <span>Receiver</span>
                <font-awesome-icon 
                  :icon="sortBy === 'receiver' && sortOrder === 'ASC' ? 'chevron-up' : 'chevron-down'" 
                  class="tw-h-3 tw-w-3"
                  :class="sortBy === 'receiver' ? 'tw-text-slate-900' : 'tw-text-slate-300'" 
                />
              </div>
            </th>
          </tr>
        </thead>
        <tbody class="tw-divide-y tw-divide-slate-200/70">
          <DispatchTableRow
            :container="container"
            v-for="(container, containerIdx) in containers"
            :key="container.id || containerIdx"
            @toggleTripStatus="toggleTripStatus"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DispatchTableRow from './DispatchTableRow.vue';

export default defineComponent({
  props: {
    containers: Array,
    sortBy: String,
    sortOrder: String
  },
  components: {
    DispatchTableRow,
  },
  methods: {
    toggleTripStatus(containerId: number) {
      this.$emit('toggleTripStatus', containerId);
    },
    updateSortBy(val: string) {
      this.$emit('updateSortBy', val);
    },
  },
});
</script>

<style lang="scss" scoped>
</style>
